import { nextActionResults } from 'json/trust-deed'

export function formatActionAcceptableResult(value) {
  for (let item of nextActionResults) {
    if (item.key === value) {
      return item.value
    }
  }
  if (value) {
    console.error('[nextActionResults]方法未找到对应的item', value)
  }
  return ''
}